import React from "react";
import { navigate, RouteComponentProps } from "@reach/router";
import { PageHeader } from "ui/Header";
import axios from "axios";
import { Box, Button, Grid, Radio, Tab, Tabs } from "@material-ui/core";
import Paper from "ui/Paper";
import { a11yProps } from "utils";
import { TabPanel } from "../Settings/Levels";
import { useStyles } from "pages/Tutoring/CardInfo";
import { SelectedIcon } from "ui/Custom/Icons";
import { CandidatsColumns, EntrepriseJobOfferColumns, JOB_OFFER_STATUS } from "./data";
import Table from "ui/Table";

export interface DefaultPageProps extends RouteComponentProps {
  noPageTitle?: boolean;
}

export const Home: React.FC<DefaultPageProps> = (props) => {
  const classes = useStyles();

  const [data, setData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [openValidate, setOpenValidate] = React.useState(false);
  const [value, setValue] = React.useState(0);

  const handleValue = React.useCallback(
    (e: React.ChangeEvent<{}>, newValue: number) => {
      setValue((prevValue) => newValue);
    },
    [value, setValue]
  );

  React.useEffect(() => {
    axios('/api/v1/entreprises/' + props["id"])
      .then(res => {
        setData(res.data)
      })
  }, []);

  return (
    <>

      <PageHeader back title="Entreprises">
      </PageHeader>

      <Paper>
        <Tabs
          onChange={handleValue}
          value={value}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Details" {...a11yProps(0)} />
          <Tab label="Offres d'emploi" {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          <Grid item xs={12} md={6}>
            {
              data &&
              <Box p={2}>
                <div className={classes.info}>
                  <span className={classes.nameField}>Nom  :</span>
                  <span className={classes.contentField}>{data?.name}</span>
                </div>
                <div className={classes.info}>
                  <span className={classes.nameField}>Responsable :</span>
                  <span className={classes.contentField}>
                    {data?.owner_name}
                  </span>
                </div>
                <div className={classes.info}>
                  <span className={classes.nameField}>Email :</span>
                  <span className={classes.contentField}>{data?.login_email}</span>
                </div>
                <div className={classes.info}>
                  <span className={classes.nameField}>Téléphone :</span>
                  <span className={classes.contentField}>{data?.phonenumber}</span>
                </div>
                <div className={classes.info}>
                  <span className={classes.nameField}>adresse :</span>
                  <span className={classes.contentField}>{data?.address}</span>
                </div>
              </Box>
            }
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Table
            rowsIdentifier="id"
            columns={EntrepriseJobOfferColumns}
            data={data?.joboffers}
            onRowClick={(row) => {
              navigate("/emplois/offres/" + row.id)
            }}
          />
        </TabPanel>
      </Paper>
    </>
  );
};

export default Home;
